import { render, staticRenderFns } from "./s-field.vue?vue&type=template&id=644fc426"
import script from "./s-field.vue?vue&type=script&lang=js"
export * from "./s-field.vue?vue&type=script&lang=js"
import style0 from "./s-field.vue?vue&type=style&index=0&id=644fc426&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports